module.exports = __webpack_public_path__ + "img/logo.3db7ab22.svg";